import { BffGamesCategory } from '@lucky7ventures/bff-types';

export const GAMES_FEATURES_MEXICO: readonly BffGamesCategory[] = [
  BffGamesCategory.BonusGame,
  BffGamesCategory.BuyFeature,
  BffGamesCategory.InfinityReels,
  BffGamesCategory.FixedJackpots,
  BffGamesCategory.Multiplier,
  BffGamesCategory.Bingo,
  BffGamesCategory.BonusWheel,
  BffGamesCategory.Gamble,
  BffGamesCategory.Respins,
  BffGamesCategory.RandomWildsAdditionalWilds,
  BffGamesCategory.StickyWilds,
  BffGamesCategory.Avalanche,
  BffGamesCategory.ClusterPays,
  BffGamesCategory.LevelUp,
  BffGamesCategory.ExpandingSymbols,
  BffGamesCategory.PaidRespin,
  BffGamesCategory.SpreadingWildsOrWildRush,
  BffGamesCategory.ExpandingWildWithRespin,
  BffGamesCategory.WildNudge,
  BffGamesCategory.Megaways,
  BffGamesCategory.LockedReels,
  BffGamesCategory.AdditiveSymbol,
];

export const GAMES_FEATURES_THAILAND: readonly BffGamesCategory[] = [
  BffGamesCategory.BonusGame,
  BffGamesCategory.BuyFeature,
  BffGamesCategory.InfinityReels,
  BffGamesCategory.FixedJackpots,
  BffGamesCategory.Multiplier,
  BffGamesCategory.Bingo,
  BffGamesCategory.BonusWheel,
  BffGamesCategory.Gamble,
  BffGamesCategory.Respins,
  BffGamesCategory.RandomWildsAdditionalWilds,
  BffGamesCategory.StickyWilds,
  BffGamesCategory.Avalanche,
  BffGamesCategory.ClusterPays,
  BffGamesCategory.LevelUp,
  BffGamesCategory.ExpandingSymbols,
  BffGamesCategory.PaidRespin,
  BffGamesCategory.SpreadingWildsOrWildRush,
  BffGamesCategory.ExpandingWildWithRespin,
  BffGamesCategory.WildNudge,
  BffGamesCategory.Megaways,
  BffGamesCategory.LockedReels,
  BffGamesCategory.AdditiveSymbol,
];

export const thailandTopGameProvidersSlugs = [
  'pragmatic-play',
  'pg-soft',
  'microgaming-asia',
  'sa-gaming',
  'asia-gaming',
  'ae-sexy-baccarat',
  'spadegaming',
  'cq9',
  'jili-asia',
  'ka-gaming',
  'habanero',
  'wm-casino',
  'oriental-game',
  'simple-play',
  'fa-chai',
  'yggdrasil',
  'netent',
  'evolution',
  'play-n-go',
  'red-tiger',
  'big-time-gaming',
  'blueprint',
  'betsoft',
  'relax-gaming',
  'push-gaming',
  'quickspin',
  'playson',
  'thunderkick',
  'wazdan',
  'nolimit-city',
  'hacksaw-gaming',
  'high-5-games',
  'reelplay',
  'skywind',
  'spribe',
  'swintt',
  'endorphina',
  'booming-games',
  '3-oaks-gaming',
  'gamomat',
  'golden-hero',
  'kalamba-games',
  'reevo',
  '4theplayer',
  'avatar-ux',
  'jelly-entertainment',
  'peter--sons',
];

export const GIG_GAMES_CATEGORIES_RECORD: Partial<Record<BffGamesCategory, string>> = {
  [BffGamesCategory.LastPlayed]: 'games.categories.last-played',
  [BffGamesCategory.FavouriteGames]: 'games.categories.favourite-games',
  [BffGamesCategory.Recommended]: 'games.categories.recommended',
  [BffGamesCategory.NewGames]: 'games.categories.new-games',
  [BffGamesCategory.LiveCasino]: 'games.categories.live-casino',
  [BffGamesCategory.Slots]: 'games.categories.slots',
  [BffGamesCategory.Jackpots]: 'games.categories.jackpots',
  [BffGamesCategory.TableGames]: 'games.categories.table-games',
  [BffGamesCategory.AllGames]: 'games.categories.all-games',
  [BffGamesCategory.OntarioPlayersLove]: 'games.categories.ontario-players-love',
  [BffGamesCategory.TheNewReelThing]: 'games.categories.the-new-reel-thing',
  [BffGamesCategory.BuyFeature]: 'games.categories.buy-feature',
  [BffGamesCategory.GameShows]: 'games.categories.game-shows',
  [BffGamesCategory.Blackjack]: 'games.categories.blackjack',
  [BffGamesCategory.Baccarat]: 'games.categories.baccarat',
  [BffGamesCategory.Roulette]: 'games.categories.roulette',
  [BffGamesCategory.Poker]: 'games.categories.poker',
  [BffGamesCategory.AsianGames]: 'games.categories.asian-games',
  [BffGamesCategory.CrashGames]: 'games.categories.crash-games',
  [BffGamesCategory.ArcadeGames]: 'games.categories.arcade-games',
  [BffGamesCategory.Plinko]: 'games.categories.plinko',
  [BffGamesCategory.HalloweenGames]: 'games.categories.halloween-games',
  [BffGamesCategory.Popular]: 'games.categories.popular',
  [BffGamesCategory.VirtualSports]: 'games.categories.virtual-sports',
};

export const GAMES_FEATURES_CANADA: BffGamesCategory[] = [
  BffGamesCategory.AdditiveSymbol,
  BffGamesCategory.Avalanche,
  BffGamesCategory.Bingo,
  BffGamesCategory.BonusGame,
  BffGamesCategory.BonusWheel,
  BffGamesCategory.BuyFeature,
  BffGamesCategory.ClusterPays,
  BffGamesCategory.ExpandingSymbols,
  BffGamesCategory.ExpandingWildWithRespin,
  BffGamesCategory.FixedJackpots,
  BffGamesCategory.Gamble,
  BffGamesCategory.InfinityReels,
  BffGamesCategory.LevelUp,
  BffGamesCategory.LockedReels,
  BffGamesCategory.Megaways,
  BffGamesCategory.Multiplier,
  BffGamesCategory.PaidRespin,
  BffGamesCategory.RandomWildsAdditionalWilds,
  BffGamesCategory.Respins,
  BffGamesCategory.SpreadingWildsOrWildRush,
  BffGamesCategory.StickyWilds,
  BffGamesCategory.WildNudge,
];

export const GAMES_FEATURES_NORMAL: BffGamesCategory[] = [
  BffGamesCategory.AdditiveSymbol,
  BffGamesCategory.Avalanche,
  BffGamesCategory.Bingo,
  BffGamesCategory.BonusGame,
  BffGamesCategory.BonusWheel,
  BffGamesCategory.BonusBuy,
  BffGamesCategory.ClusterPays,
  BffGamesCategory.ExpandingSymbols,
  BffGamesCategory.ExpandingWildWithRespin,
  BffGamesCategory.FixedJackpots,
  BffGamesCategory.Gamble,
  BffGamesCategory.InfinityReels,
  BffGamesCategory.LevelUp,
  BffGamesCategory.LockedReels,
  BffGamesCategory.Megaways,
  BffGamesCategory.Multiplier,
  BffGamesCategory.PaidRespin,
  BffGamesCategory.RandomWildsAdditionalWilds,
  BffGamesCategory.Respins,
  BffGamesCategory.SpreadingWildsOrWildRush,
  BffGamesCategory.StickyWilds,
  BffGamesCategory.WildNudge,
];

export const ADDITIONAL_GAME_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.OntarioPlayersLove,
  BffGamesCategory.TheNewReelThing,
  BffGamesCategory.CrashGames,
  BffGamesCategory.ArcadeGames,
  BffGamesCategory.GameShows,
  BffGamesCategory.Baccarat,
  BffGamesCategory.Blackjack,
  BffGamesCategory.AsianGames,
  BffGamesCategory.Roulette,
  BffGamesCategory.Poker,
  BffGamesCategory.Plinko,
  BffGamesCategory.Popular,
  BffGamesCategory.VirtualSports,
];

export const SHARED_GAME_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.LastPlayed,
  BffGamesCategory.FavouriteGames,
  BffGamesCategory.Recommended,
  BffGamesCategory.NewGames,
  BffGamesCategory.HalloweenGames,
  BffGamesCategory.TableGames,
  BffGamesCategory.Slots,
  BffGamesCategory.Jackpots,
  BffGamesCategory.AllGames,
];

export const GAME_CATEGORY_NAV_ONTARIO_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.Recommended,
  BffGamesCategory.Popular,
  BffGamesCategory.OntarioPlayersLove,
  BffGamesCategory.TheNewReelThing,
  BffGamesCategory.BuyFeature,
  BffGamesCategory.NewGames,
  BffGamesCategory.Jackpots,
  BffGamesCategory.Slots,
  BffGamesCategory.LiveCasino,
  BffGamesCategory.TableGames,
  BffGamesCategory.CrashGames,
  BffGamesCategory.ArcadeGames,
  BffGamesCategory.Plinko,
  BffGamesCategory.VirtualSports,
  BffGamesCategory.AllGames,
];

export const GAME_CATEGORY_NAV_ROC_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.Recommended,
  BffGamesCategory.Popular,
  BffGamesCategory.NewGames,
  BffGamesCategory.Jackpots,
  BffGamesCategory.Slots,
  BffGamesCategory.LiveCasino,
  BffGamesCategory.TableGames,
  BffGamesCategory.CrashGames,
  BffGamesCategory.ArcadeGames,
  BffGamesCategory.Plinko,
  BffGamesCategory.VirtualSports,
  BffGamesCategory.AllGames,
];

export const GAME_CATEGORY_NAV_NORMAL_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.Recommended,
  BffGamesCategory.Popular,
  BffGamesCategory.NewGames,
  BffGamesCategory.Jackpots,
  BffGamesCategory.Slots,
  BffGamesCategory.LiveCasino,
  BffGamesCategory.TableGames,
  BffGamesCategory.CrashGames,
  BffGamesCategory.ArcadeGames,
  BffGamesCategory.Plinko,
  BffGamesCategory.AllGames,
];

export const GAME_CATEGORY_NAV_SHARED_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.Recommended,
  BffGamesCategory.NewGames,
  BffGamesCategory.LiveCasino,
  BffGamesCategory.Slots,
  BffGamesCategory.Jackpots,
  BffGamesCategory.TableGames,
  BffGamesCategory.AllGames,
];

export const GAME_CATEGORY_NAV_LIVE_CASINO_CATEGORIES: BffGamesCategory[] = [
  BffGamesCategory.GameShows,
  BffGamesCategory.Blackjack,
  BffGamesCategory.Baccarat,
  BffGamesCategory.Roulette,
  BffGamesCategory.Poker,
  BffGamesCategory.AsianGames,
];
